module.exports = __webpack_public_path__ + "static/media/news-placeholder-img.209c4682.webp";